import { render } from "./DowelTab.vue?vue&type=template&id=4bb2dae8"
import script from "./DowelTab.vue?vue&type=script&lang=js"
export * from "./DowelTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__